define('plugin/paid-attributes/step/PaidAttributesStep',['require','lib/controller/booking/BaseStep','plugin/paid-attributes/view/step/AttributeLayout','plugin/paid-attributes/view/step/AttributeListView','plugin/paid-attributes/view/step/AttributeTotalsView','view/controller/booking/datetime/SidebarView'],function (require) {

	var BaseStep = require('lib/controller/booking/BaseStep');
    var AttributeLayout = require('plugin/paid-attributes/view/step/AttributeLayout');
    var AttributeListView = require('plugin/paid-attributes/view/step/AttributeListView');
    var AttributeTotalsView = require('plugin/paid-attributes/view/step/AttributeTotalsView');
    var SidebarView = require('view/controller/booking/datetime/SidebarView');
	
	return BaseStep.extend({
		
		_step: 'paid_attributes',
		_skipStep: false,
        
        _shouldUpdateBookingModel: false,
        _isStepViewed: false,

        /**
		 * Inits instance, collection, subscribe to events
		 */
		initialize: function() {
	        BaseStep.prototype.initialize.call(this);

            this._stepManager.showStep('paid_attributes');

	        this._paidAttributeCollection = this.getOption('collection');

	        this.listenTo(this._bookingModel, 'change:products', this.updateInfo);
	        this.listenTo(this._paidAttributeCollection, 'sync', this.onDataFetch);

            // The add-ons collection's fetch is kicked off as soon as service_id is
            // set (in PaidAttributesPlugin), independently of when this step object
            // gets constructed - which itself only happens once earlier steps (e.g.
            // location/service) resolve. If the fetch wins that race, its 'sync' has
            // already fired and won't fire again, so the listener above would never
            // run - leaving getNextStep()/isValid() permanently unaware this step
            // should be skipped. Catch up here, synchronously, without going through
            // onDataFetch()/done() to avoid re-entering the step manager while it's
            // still constructing this step - isValid() is checked right after this
            // constructor returns, in the same synchronous getNextStep() pass.
            if (this._paidAttributeCollection._once_synced) {
                this._updateSkipState();
            }
	    },

        /**
         * Decides whether this step should be skipped, based on the current
         * (already fetched) state of the add-ons collection.
         */
        _updateSkipState: function () {
            if (this._paidAttributeCollection.length < 1 && this._bookingModel.get('service_id')) {
                this.setIsSkipped(true);
            } else {
                this.setIsSkipped(false);
            }
        },

        initStep: function () {
            if (this._bookingModel.get('addons') != this._bookingModel.getAddons()) {
                this._shouldUpdateBookingModel = true;
            }
        },
        
        /**
		 * Calls when collection fetched from server
		 */
		onDataFetch: function () {
			this.triggerStepEvent('fetch');
			this.updateInfo();

            this._updateSkipState();

            if (this._shouldUpdateBookingModel) {
                var addons = this._bookingModel.get('addons');
                if (addons) addons = addons.split(',');
                
                var collection = this._paidAttributeCollection;
                _.each(addons, function (id) {
                    var productModel = collection.get(id);
                    if (productModel) {
                        productModel.set('qty', 1); 
                    }
                });
            }

			this.done();
		},
        
        /**
	     * Returns step view
	     * 
	     * @return AttributeLayout
	     */
		getView: function () {
            this._isStepViewed = true;
            var layout = new AttributeLayout({
                paidAttributeCollection: this._paidAttributeCollection
            });
            
            this.listenTo(layout, 'show', this._showRegions);
            this.listenTo(layout, 'go:next', this._onGoNext);

            return layout;
		},
        
        _onGoNext: function () {
            var urlBuilder = this.getOption('stepManager').getUrlBuilder();
            var fragment = urlBuilder.buildUrl(this.getOption('stepManager').getRouteName(), {
                addons: this._bookingModel.getAddons() || 'no'
            });

            var fragmentBefore = Backbone.history.fragment;
            Backbone.history.navigate(fragment, {'trigger': true});

            // Backbone.history.navigate() silently no-ops when the target fragment
            // is already the current one - e.g. a default-selected add-on already
            // puts addons=<id> in the URL before Next is ever clicked, so clicking
            // Next would otherwise do nothing. Advance the step directly instead;
            // isValid() now correctly returns true since addons/_isStepViewed are
            // already set.
            if (Backbone.history.fragment === fragmentBefore) {
                this.done();
            }
        },
        
        /**
         * @todo why this works in such a strange way?
         * @return Boolean
         */
        isValid: function () {
            if (this.isStepSkipped()) return true;
            
            //TODO some condition to check when all necessary addons are selected and "next" clicked?
            if (this._bookingModel.get('addons') && this._isStepViewed) return true;
            
            return false;
        },

        isStepSkipped: function () {
            var isSkipped = BaseStep.prototype.isStepSkipped.call(this);
            //console.trace(isSkipped);
            return isSkipped;
        },
        
        /**
         * Returns sidebar booking info view
         *
         * @protected
         * @return SidebarView
         */
        _getSideBarView: function () {
            return new SidebarView({
                model: this._bookingModel
            });
        },
        
        /**
         * When layout appears add date and time view to layout regions
         * 
         * @param DateTimeStepDefaultLayout layout
         */
        _showRegions: function (layout) {
            if (layout.supportsSidebar()) {
                layout.getSideBarRegion().show(this._getSideBarView());
            }
            
            var view = new AttributeListView({
	    		bookingModel: this._bookingModel,
	    		collection: this._paidAttributeCollection
	    	});
            layout.getContentRegion().show(view);

            layout.getTotalsRegion().show(new AttributeTotalsView({
                bookingModel: this._bookingModel,
            }));
        },
        
    });
    
});

